import React, { ReactElement, useCallback } from 'react';
import * as css from './DTCPanel.module.scss';
import 'src/css/themes.scss';
import { CheckedDTC, ConnectedVehicleRec, ImportedDTC } from 'src/models';
import { Checkbox } from '@framework-controls/core';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    checkedDtc: CheckedDTC[];
    importedDtc: ImportedDTC[];
    mode: string;
    index: number;
    lastDtc: string;
    toggleDtc: (code: string) => void;
}

const DTCPanel = (props: IProps) => {
    const dtcChecked = props.checkedDtc.some(result => (result.code ===
        props.connectedVehicle.dtc[props.index].code) ? true : false);
    const toggleDtc = useCallback(() => {
        props.toggleDtc(props.connectedVehicle.dtc[props.index].code);
    }, [props.toggleDtc, props.index, props.connectedVehicle.dtc]);


    let dtcCheckBox: ReactElement = <div className={css.dtcIcon}></div>;
    if (props.mode !== 'P') {
        if (props.importedDtc.findIndex((result => result.code === props.connectedVehicle.dtc[props.index].code)) !== -1) {
            dtcCheckBox =
                <div className={css.checkboxArea}>
                    <div>
                        <Checkbox
                            id={'dtcCheckbox'}
                            size={'rg'}
                            variant={'primaryCkb'}
                            checked={dtcChecked}
                            onChange={toggleDtc}>
                        </Checkbox>
                    </div>
                    <div className={css.asterisk}>*</div>
                </div>;
        } else {
            dtcCheckBox =
                <div className={css.dtcIcon}>
                    <Checkbox
                        id={'dtcCheckbox'}
                        size={'rg'}
                        variant={'primaryCkb'}
                        checked={dtcChecked}
                        onChange={toggleDtc}>
                    </Checkbox>
                </div>;
        }
    }

    let statusArea: ReactElement | null = null;
    if (props.connectedVehicle.dtc[props.index].status) {
        if (props.connectedVehicle.dtc[props.index].statusCode || props.connectedVehicle.dtc[props.index].statusDesc) {
            statusArea =
                <div>
                    <div>{props.connectedVehicle.dtc[props.index].status}</div>
                    <div>{props.connectedVehicle.dtc[props.index].statusCode}</div>
                    <div>{props.connectedVehicle.dtc[props.index].statusDesc}</div>
                </div>;
        } else {
            statusArea =
                <div>
                    <div>{props.connectedVehicle.dtc[props.index].status}</div>
                </div>;
        }
    } else {
        if (props.connectedVehicle.dtc[props.index].statusCode || props.connectedVehicle.dtc[props.index].statusDesc) {
            statusArea =
                <div>
                    <div>{props.connectedVehicle.dtc[props.index].statusCode}</div>
                    <div>{props.connectedVehicle.dtc[props.index].statusDesc}</div>
                </div>;
        }
    }

    return (
        <div>
            <div className={css.dataRow}>
                {dtcCheckBox}
                <div className={css.dtcCode}>{props.connectedVehicle.dtc[props.index].code}</div>
                <div className={css.dtcDesc}>{props.connectedVehicle.dtc[props.index].desc}</div>
                <div className={css.dtcEmission}>{props.connectedVehicle.dtc[props.index].type}</div>
                <div className={css.dtcECMECU}>
                    <div>{props.connectedVehicle.dtc[props.index].ecm}</div>
                    <div>{props.connectedVehicle.dtc[props.index].ecu}</div>
                </div>
                <div className={css.dtcSymptom}>
                    <div>{props.connectedVehicle.dtc[props.index].symptomCode}</div>
                    <div>{props.connectedVehicle.dtc[props.index].symptomDesc}</div>
                </div>
                <div className={css.dtcStatus}>
                    {statusArea}
                </div>
            </div>
            <hr className={props.connectedVehicle.dtc[props.index].code === props.lastDtc ? css.hidden : css.dataLine}></hr>
        </div>
    );
};

export default DTCPanel;